function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25.77 56.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.54.6c-2.21,1.24-9.25,15.37-11.78,23.67-1.12,3.65-3.39,9.04-5.05,11.97C.08,40.86-.26,42.3.14,47.14c.58,6.99,2.23,8.37,9.75,8.17,3.04-.08,6.67.17,8.07.55,6.7,1.84,9.77-7.74,6.5-20.31-1.43-5.52-1.5-7.9-.51-18,1.35-13.76,1.23-12.15,1.09-14.77-.13-2.42-3.02-3.56-5.49-2.18",
    style: {
      fill: "#010101",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.25,10.16c-.46,4.26-.84,11.61-.84,16.33v8.58l-4.41-1.33c-2.42-.73-5.46-1.33-6.75-1.33s-2.34-.37-2.34-.82c0-2.1,5.12-15.54,7.56-19.85,6.95-12.26,7.95-12.49,6.77-1.57",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.62,36.62c4.39,1.59,6.02,6.38,4.33,12.68-1.12,4.17-1.27,4.29-4.34,3.64-1.75-.37-5.97-.61-9.38-.54l-6.19.13-.67-3.56c-.77-4.08-.04-7.73,2.21-11.17,1.28-1.95,2.42-2.4,6.13-2.4,2.51,0,6.07.54,7.91,1.21",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg28);
export default __webpack_public_path__ + "static/media/28.ba1de8b6b8a49da308bec48419206c2f.svg";
export { ForwardRef as ReactComponent };